(function () {
    'use strict';
    var controllerId = 'cndPBudgetAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'pBudget', 'partecipazioneId', 'aziende', 'aziendaId', 'isSuper', fn_cndPBudgetAdd]);

    function fn_cndPBudgetAdd($scope, datacontext, $uibModalInstance, pBudget, partecipazioneId, aziende, aziendaId, isSuper) {
        $scope.aziende = aziende;
        $scope.isSuper = isSuper;
        $scope.codeAttivita = '';

        $scope.cmblist = {};
        $scope.cmblist.attivita = [
            { Code: 'OS', Name: 'Orientamento specialistico', UCS: 37.30, UnaTantum: 0 }
            , { Code: 'AL', Name: 'Accompagnamento al lavoro', UCS: 76.80, UnaTantum: 0 }
            , { Code: 'TT', Name: 'Tutoraggio tirocinio', UCS: 37.30, UnaTantum: 0 }
            , { Code: 'IT', Name: 'Indennit\xE0 di tirocinio', UCS: 0, UnaTantum: 3000.0 }
            , { Code: 'PT', Name: 'Promozione di tirocinio', UCS: 0, UnaTantum: 500.0 }
            , { Code: 'DO', Name: 'Incrocio Domanda Offerta', UCS: 0, UnaTantum: 454.0 }
        ];

        if (pBudget) {
            $scope.title = 'Modifica Budget';
            $scope.record = jQuery.extend({}, pBudget); //Clona oggetto
            $scope.action = 'Edit';

            if ($scope.record.Attivita) {
                var att = _.find($scope.cmblist.attivita, function (o) { return o.Name == $scope.record.Attivita; });
                if (att != null) {
                    $scope.codeAttivita = att.Code;
                }
            }
        }
        else {
            $scope.title = 'Nuovo Budget';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.PartecipazioneId = partecipazioneId;            
            $scope.action = 'Add';
            resetParams();
        }

        if (aziendaId) {
            $scope.aziendaId = aziendaId;
            $scope.record.APLId = aziendaId;
        }

        if (partecipazioneId) {
            $scope.partecipazioneId = partecipazioneId;
            $scope.record.PartecipazioneId = partecipazioneId;
        }

        

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        
        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.open = function ($event, iOpened) {
            console.log('openCalendar');
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            $scope.opened2 = false;
            if (iOpened == 1) {
                $scope.opened1 = true;
            }
            else if (iOpened == 2) {
                $scope.opened2 = true;
            }
                
        };

        $scope.clear = function ($event, iOpened) {
            console.log('clear');
            if (iOpened == 1) {
                $scope.record.L_DtNasc = '';
                $scope.changed = true;
            }
            else if (iOpened == 2) {
                $scope.record.SGO_DDG_Dt = '';
                $scope.changed = true;
            }

        };

        $scope.format = "dd/MM/yyyy";

        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.record.Id == 0) {
                    var result = addItem($scope.record);
                    $uibModalInstance.close(result);
                }
                else {
                    var result1 = updateItem($scope.record);
                    $uibModalInstance.close(result1);
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.pBudget_add(item).then(function (data) {
                return data;
            });
        }

        function updateItem(item) {
            return datacontext.pBudget_merge(item).then(function (data) {
                return data;
            });
        }

        function resetParams() {
            $scope.record.UCS = 0;
            $scope.record.UnaTantum = 0;
            $scope.record.NOre = 0;
            $scope.record.NInterventi = 0;
            $scope.record.ImpTot = 0;
        }

        $scope.changeImpTot = function () {
            var ImpUCSNOre = 0;
            
            if ($scope.record.UCS > 0 && $scope.record.NOre > 0) {
                ImpUCSNOre = parseFloat(($scope.record.UCS * $scope.record.NOre).toFixed(2));
            }
            var ImpUnaTantumNInerventi = 0;
            if ($scope.record.UnaTantum > 0 && $scope.record.NInterventi > 0) {
                ImpUnaTantumNInerventi = parseFloat(($scope.record.UnaTantum * $scope.record.NInterventi).toFixed(2));
            }

            $scope.record.ImpTot = parseFloat((ImpUCSNOre + ImpUnaTantumNInerventi).toFixed(2));
        };

        $scope.changeAttivita = function (codeAtt) {
            if (codeAtt) {                
                var att = _.find($scope.cmblist.attivita, function (o) { return o.Code == codeAtt; });
                if (att != null) {
                    $scope.record.Attivita = att.Name;
                    if (att.UCS > 0) {
                        $scope.record.UCS = att.UCS;
                        $scope.record.UnaTantum = 0;
                        $scope.record.NInterventi = 0;
                    }
                    if (att.UnaTantum > 0) {
                        $scope.record.UnaTantum = att.UnaTantum;
                        $scope.record.UCS = 0;
                        $scope.record.NOre = 0;
                    }                    
                    $scope.changeImpTot();
                }
            }
        };

        

    }
})();